export default __webpack_public_path__ + "static/media/underline_icon_grey.44a4d63a.svg";